import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import url from "../../../url";
import useTranslate from "../../../hooks/useTranslate";
import { makeLangUrl } from "../../../helpers/makeLangUrl";
import useFormatBalance from "../../../hooks/useFormatBalance";
import * as userSelector from "../../../redux/user/selectors";
import "./styles.sass";

type CoinFestSidebarProps = {
  isSidebarOpen: boolean;
};

const CoinFestSidebar = ({ isSidebarOpen }: CoinFestSidebarProps) => {
  const point =
    "https://diswdgcu9cfva.cloudfront.net/landings/casino/coinfestival/bigpoint.webp";
  const point2 =
    "https://diswdgcu9cfva.cloudfront.net/landings/casino/coinfestival/pointsmall.webp";
  const imgSrc = isSidebarOpen ? point : point2;
  const t = useTranslate();
  const currency = useSelector(userSelector.currency);

  function replaceAllAmounts(
    template: string,
    amounts: Record<string, string>,
  ): string {
    let index = 1;

    return template.replace(/{amount}/g, () => {
      const key = `amount${index}`;
      const value = amounts[key];

      if (value !== undefined) {
        index += 1;
        return value;
      }
      return "{amount}";
    });
  }

  const currGeo = currency?.isoCode as keyof typeof geoBalances | undefined;

  const geoBalances = {
    BDT: 150000,
    KZT: 500000,
    UZS: 15000000,
    INR: 130000,
    AZN: 2000,
    PKR: 300000,
    TRY: 40000,
  } as const;

  const balanceValue = (currGeo && geoBalances[currGeo]) ?? 0;

  const formatBalance = useFormatBalance();
  const outputBalance = replaceAllAmounts(t("coin.banner.title"), {
    amount1: formatBalance(balanceValue),
  });

  return (
    <div className={`coinFestSidebar ${isSidebarOpen ? "open" : "closed"}`}>
      <NavLink to={makeLangUrl(url.routes.coinFest.index())}>
        <img className="coinFestSidebar__img" src={imgSrc} alt=" " />
        {isSidebarOpen && (
          <div className="coinFestSidebar__text">{outputBalance}</div>
        )}
      </NavLink>
    </div>
  );
};

export default CoinFestSidebar;
